import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { MdDelete } from 'react-icons/md';
import fetchLogos from '../../services/Logo_Moldura/fetchLogos';
import ThumbnailViewer from '../../services/Logo_Moldura/ThumbnailViewer';

const GalleryContainer = styled.div`
  margin-top: 20px;
  padding: 10px;
`;

const GalleryTitle = styled.h3`
  font-size: 16px;
  margin-bottom: 15px;
`;

const ThumbnailGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const ThumbnailContainer = styled.div`
  position: relative;
  margin: 10px;
`;

const DeleteButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  color: #ff0000;
  cursor: pointer;
  font-size: 20px;
  padding: 5px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.2s;

  &:hover {
    background-color: rgba(255, 0, 0, 0.1);
    transform: scale(1.1);
  }
`;

const EmptyMessage = styled.p`
  color: #666;
  font-style: italic;
  padding: 20px;
  text-align: center;
  width: 100%;
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 20px;
  color: #666;
`;

const ErrorMessage = styled.div`
  color: #d32f2f;
  padding: 15px;
  background-color: #ffebee;
  border-radius: 4px;
  margin-bottom: 15px;
`;

const LogosGallery = ({ idRede, onSelectLogo, onDeleteLogo }) => {
  const [logos, setLogos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const loadLogos = async () => {
      if (!idRede) {
        setLogos([]);
        return;
      }
      
      setLoading(true);
      setError(null);
      
      try {
        const result = await fetchLogos(idRede);
        
        if (result.success) {
          setLogos(result.logos);
        } else {
          setError(result.message || 'Erro ao carregar logos');
          setLogos([]);
        }
      } catch (err) {
        console.error('Erro ao buscar logos:', err);
        setError('Erro ao carregar logos. Tente novamente.');
        setLogos([]);
      } finally {
        setLoading(false);
      }
    };
    
    loadLogos();
  }, [idRede]);
  
  const handleThumbnailClick = (logo) => {
    if (onSelectLogo) {
      onSelectLogo(logo);
    }
  };

  const handleDelete = (e, nomeArquivo) => {
    e.stopPropagation();
    if (onDeleteLogo) {
      onDeleteLogo(nomeArquivo);
    }
  };
  
  if (loading) {
    return <LoadingMessage>Carregando logos...</LoadingMessage>;
  }
  
  return (
    <GalleryContainer>
      <GalleryTitle>Logos Disponíveis</GalleryTitle>
      
      {error && <ErrorMessage>{error}</ErrorMessage>}
      
      <ThumbnailGrid>
        {logos.length > 0 ? (
          logos.map((logo) => (
            <ThumbnailContainer key={logo.id}>
              <ThumbnailViewer
                nomeArquivo={logo.nome}
                idRede={idRede}
                onClick={() => handleThumbnailClick(logo)}
              />
              <DeleteButton 
                onClick={(e) => handleDelete(e, logo.nome)}
                title="Excluir logo"
              >
                <MdDelete />
              </DeleteButton>
            </ThumbnailContainer>
          ))
        ) : (
          <EmptyMessage>
            {!error && 'Nenhum logo encontrado para esta rede.'}
          </EmptyMessage>
        )}
      </ThumbnailGrid>
    </GalleryContainer>
  );
};

export default LogosGallery; 